import { FileText } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";

// Renders a lawyer-approved legal document (title + blocks) in a scrollable,
// mobile-friendly modal. The legal body text stays verbatim Turkish.
export function LegalTextModal({ open, onOpenChange, doc, testid }) {
  if (!doc) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={testid}
        className="max-h-[85vh] max-w-2xl gap-0 overflow-hidden rounded-3xl border-2 border-[#26422A]/40 bg-[#FFFDF4] p-0"
      >
        <DialogHeader className="border-b border-[#26422A]/15 px-6 pb-4 pt-6 text-left">
          <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-2xl bg-[#26422A]">
            <FileText className="h-5 w-5 text-[#FFEEBC]" />
          </div>
          <DialogTitle className="font-display text-lg font-black leading-snug text-[#26422A]">
            {doc.title}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {doc.title}
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[62vh] px-6 py-5">
          <div className="space-y-4 pr-2">
            {doc.blocks.map((b, i) => (
              <div key={i}>
                {b.h && (
                  <h3 className="mb-1 font-display text-sm font-bold text-[#26422A]">
                    {b.h}
                  </h3>
                )}
                <p className="whitespace-pre-line text-sm leading-relaxed text-[#26422A]/90">
                  {b.p}
                </p>
              </div>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
